import React, {useState} from 'react'
import Spinner from 'react-bootstrap/Spinner'
import './admin-login.scss';
import {Redirect} from "react-router";
import {loginAction} from '../redux/actions/auth'
import {connect} from "react-redux";
import logoImg from '~/assets/logo-text-vertical.svg';

const AdminLogin = ({config, ...props}) => {

    const defaultValues = {
        email: config.debug ? 'digital@twelfthman.co' : '',
        password: config.debug ? 'admin' : '',
    };

    const [email, setEmail] = useState(defaultValues.email);
    const [password, setPassword] = useState(defaultValues.password);

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const handleLoginUser = () => {

        setLoading(true);

        props.dispatch(loginAction(email, password)).then((response) => {

            setLoading(false);

            if (response?.status !== 200) {
                setError(response?.data?.message || 'Unknown error!');
            }
        });
    };

    if (props.isAuthenticated) {
        return <Redirect to="/"/>
    }

    return (
        <div className="container container-login h-100 d-flex">
            <div className="row align-items-center">
                <div className="col-12">

                    <div className="card shadow p-sm-4 p-0 bg-white">
                        <div className="card-body text-center">
                            <div className="row">

                                <div className="col-12 mb-3">
                                    <img className="logo mb-3" src={logoImg}/>
                                    <h1 className="text-primary mb-0">Login</h1>
                                </div>
                                <div className="col-12 mb-3">
                                    <p>Enter your email address and password.</p>
                                </div>
                                <div className="col-12">
                                    <form>
                                        {error && (
                                            <div className="alert alert-danger" role="alert">
                                                {error}
                                            </div>
                                        )}
                                        <div className="form-group">
                                            <label className="form-label w-100 text-left">Email</label>

                                            <input onChange={e => setEmail(e.target.value)}
                                                   value={email}
                                                   className="form-control"
                                                   type="text"/>
                                        </div>
                                        <div className="form-group description">
                                            <label className="form-label w-100 text-left">Password</label>

                                            <input onChange={e => setPassword(e.target.value)}
                                                   value={password}
                                                   className="form-control"
                                                   type="password"/>

                                        </div>
                                        <div className="form-group mb-0">
                                            <button onClick={handleLoginUser} type="button" disabled={loading}
                                                    className="btn btn-primary w-100">
                                                {loading && <Spinner size="sm" animation="border"/>}
                                                <span>Login</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


const mapStateToProps = (state) => ({
    user: state.auth.user,
    isAuthenticated: state.auth.isAuthenticated,
    config: state.config,
});

export default connect(mapStateToProps)(AdminLogin);
